import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const openUnlimitedUploadInfo = () => openPopupHelper({ popupName: popupNames.UNLIMITED_UPLOAD_INFO_MODAL });
